export const PERMISSION = {
  FORBIDDEN: false,
  DISALLOWED: null,
  ALLOWED: true,
};

export type Permission = (typeof PERMISSION)[keyof typeof PERMISSION];
